import styled from 'styled-components';
import { COLOR } from '@src/styles/color';

const StyledImportantTag = styled.div`
  position: absolute;
  top: ${(props) => props.top || '8px'};
  left: ${(props) => props.right || '8px'};
  padding: ${(props) => props.padding || ''};
  background: ${(props) => props.bgColor || COLOR.primary};
  color: ${(props) => props.color || COLOR.white};
  border-radius: ${(props) => props.borderRadius || '8xp'};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  .new-label-text {
    color: ${(props) => props.colorText || COLOR.white};
    text-transform: none;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: -0.4px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 4px;
    padding-top: 4px;
  }
`;
export { StyledImportantTag };
